import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Product } from '../models/Product';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  private apiUrl = environment.apiUrl + '/api/products';

  constructor(private http: HttpClient) {}

  // GET: obtener todos los productos
  getAll(): Observable<Product[]> {
    return this.http.get<Product[]>(this.apiUrl);
  }

  // GET: obtener un producto por su código
  getById(id: number): Observable<Product> {
    return this.http.get<Product>(`${this.apiUrl}/${id}`);
  }

  // POST: agregar un producto
  add(product: Product): Observable<any> {
    return this.http.post(`${this.apiUrl}/add`, product);
  }

  // PUT: editar un producto
  edit(product: Product): Observable<any> {
    return this.http.put(`${this.apiUrl}/edit`, product);
  }

  // DELETE: eliminar un producto
  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  // GET: productos por clase
  getByClass(fkClase: number): Observable<Product[]> {
    return this.http.get<Product[]>(`${this.apiUrl}/class/${fkClase}`);
  }
}
